import io from 'socket.io-client';
import { SOCKET_BASEURL } from '../constant';

const socket = io(SOCKET_BASEURL, {});
export default socket;